import React, { useEffect, useState } from "react";
import { Col, Row, InputGroup, FormControl, Button } from "react-bootstrap";
import backbutton from "../../images/backbutton.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getUsers,
  resetListRecord,
  resetUserRecord,
  count
} from "../../reducers/commonReducer";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import socket from "./socket";
import { shortTextMsg } from "../../const";

const Sidebar = ({ showBrowserNotification }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  let userId = queryParams.get("userid");
  let pagenumber = queryParams.get("pagenumber");

  // const [selectedChat, setSelectedChat] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(pagenumber ? +pagenumber : 1);

  const { getUsersData } = useSelector((state) => state.commonReducer);
  useEffect(() => {
    dispatch(resetUserRecord());
    dispatch(getUsers({page}));
  }, [dispatch, pagenumber]);

  useEffect(() => {
    const handleNewMessage = (newMsg) => {
      try {
        const parsedMsg = JSON.parse(newMsg);
        if (parsedMsg?.content) {
          showBrowserNotification("New Message", parsedMsg.content);
        }
        // if (parsedMsg?.newUser === true) {
        dispatch(resetUserRecord());
        dispatch(getUsers());
        // }
      } catch (error) {
        console.error("Failed to parse new message", error);
      }
    };

    socket.on("newMessage", handleNewMessage);
  }, [dispatch, getUsersData]);

  // useEffect(() => {
  //   if (userId && getUsersData?.length) {
  //     const selected = getUsersData.find(
  //       (user) => String(user.id) === String(userId)
  //     );
  //     if (selected) setSelectedChat(selected);
  //   }
  // }, [userId, getUsersData]);

  const filteredUsers = getUsersData?.filter((chat) =>
    chat.username?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Row>
        <Col md={3} xs={11} className="sidebar d-flex flex-column p-0 w-100">
          <div className="search-bar px-3 py-2 border-end border-bottom">
            <InputGroup>
              <FormControl
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>
          </div>
          <div className="chat-list flex-grow-1 overflow-auto">
            {filteredUsers?.length ? filteredUsers?.map((chat, index) => (
              <div
                key={chat.id || index}
                className={`${
                  String(userId) === String(chat?.id) ? "bg-gary" : ""
                } chat-item d-flex align-items-center p-3 border-bottom`}
                onClick={() => {
                  if(String(userId) !== String(chat?.id)){
                    localStorage.setItem("touser", chat?.id);
                    dispatch(resetListRecord());
                    dispatch(count({ id: String(chat?.id) }));
                    dispatch(resetUserRecord());
                    dispatch(getUsers());
                    navigate(
                      `/whatsapp?userid=${chat?.id}&username=${chat.username}&name=${chat.name}&tempUser=${chat?.tempUser}&customerId=${chat.id}`
                    );
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                <div
                  className={`rounded-circle text-white d-flex align-items-center justify-content-center me-2 ${chat?.tempUser ? `bg-primary` : `bg-success`}`}
                  style={{
                    height: "50px",
                    width: "50px",
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  {(chat?.tempUser ? chat.username : chat.name)?.charAt(0).toUpperCase()}
                </div>
                <div className="flex-grow-1">
                  <div className="fw-bold">{chat?.tempUser ? chat.username : chat.name}</div>
                  <div className="text-muted small">
                    {shortTextMsg(chat.newmessage?.content || "", 5) ||
                      "No messages yet"}
                  </div>
                </div>
                <div className="text-muted small ms-2">
                  {String(userId) !== String(chat?.id) &&
                    chat.unreadMessageCnt > 0 && (
                      <span
                        className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-2"
                        style={{
                          height: "15px",
                          width: "15px",
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {chat.unreadMessageCnt}
                      </span>
                    )}
                  {chat.updateMessage
                    ? moment(chat.updateMessage).format("h:mmA")
                    : ""}
                </div>
              </div>
            )) : <p className="text-center mt-5 text-danger"><b>Record Not Found..</b></p>}
           <Row className="mt-2">
              <Col md={6}>
                <Button onClick={() =>{
                  navigate(`/whatsapp?pagenumber=${page - 1}`);
                  setPage(page - 1);
                }} variant={"warning"} className="px-3 py-2"><i className="bi bi-arrow-left"></i></Button>
              </Col>
              <Col md={6}>
                <Button onClick={() =>{
                  navigate(`/whatsapp?pagenumber=${page + 1}`);
                  setPage(page + 1);
                }} variant={"warning"} className="px-3 py-2 float-right"><i className="bi bi-arrow-right"></i></Button>
              </Col>
            </Row> 
            {/* // : null} */}
          </div>
          <div
            onClick={() => navigate(`/users`)}
            className="cursor-pointer"
            style={{
              position: "fixed",
              top: "96%",
              left: "0",
              transform: "translateY(-50%)",
              zIndex: 1000,
            }}
          >
            <img
              src={backbutton}
              alt="upload"
              style={{
                width: "75px",
                height: "75px",
                padding: "10px",
                borderRadius: "50%",
              }}
            />
          </div>
        </Col>
      </Row>
      {/* <ChatArea selectedChat={selectedChat} /> */}
    </>
  );
};

export default Sidebar;
